// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2j_Js","inner":"Form_inner__u--Ze","range":"Form_range__PKNLo","name":"Form_name__3MmY-","actions":"Form_actions__1CWR_"};